export default "__VITE_ASSET__DlIwyxw8__"